var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "x mark",
    d: "M24 48C30.3652 48 36.4697 45.4714 40.9706 40.9706C45.4714 36.4697 48 30.3652 48 24C48 17.6348 45.4714 11.5303 40.9706 7.02944C36.4697 2.52856 30.3652 0 24 0C17.6348 0 11.5303 2.52856 7.02944 7.02944C2.52856 11.5303 0 17.6348 0 24C0 30.3652 2.52856 36.4697 7.02944 40.9706C11.5303 45.4714 17.6348 48 24 48ZM16.4062 16.4062C17.2875 15.525 18.7125 15.525 19.5844 16.4062L23.9906 20.8125L28.3969 16.4062C29.2781 15.525 30.7031 15.525 31.575 16.4062C32.4469 17.2875 32.4562 18.7125 31.575 19.5844L27.1687 23.9906L31.575 28.3969C32.4562 29.2781 32.4562 30.7031 31.575 31.575C30.6937 32.4469 29.2687 32.4562 28.3969 31.575L23.9906 27.1687L19.5844 31.575C18.7031 32.4562 17.2781 32.4562 16.4062 31.575C15.5344 30.6937 15.525 29.2687 16.4062 28.3969L20.8125 23.9906L16.4062 19.5844C15.525 18.7031 15.525 17.2781 16.4062 16.4062Z",
    fill: "#BB4E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmark);
export default __webpack_public_path__ + "static/media/xmark.e85ad1d1ccb745597fe42b9101d97454.svg";
export { ForwardRef as ReactComponent };